<template>
    <section class="container">
        <div v-for="(section, index) of agbSections" :key="index">
            <b-collapse 
                class="card" 
                animation="slide" 
                aria-id="contentIdForA11y3"
                :open=false>
                <template #trigger="props">
                    <div
                        class="card-header"
                        role="button"
                        aria-controls="contentIdForA11y3"
                        :aria-expanded="props.open">
                        <p class="card-header-title textleft">
                            {{section.agbSectionTitle}}
                        </p>
                        <a class="card-header-icon">
                            <b-icon
                                :icon="props.open ? 'menu-down' : 'menu-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content linebreak textleft">
                        {{section.agbSectionContent}}
                    </div>
                </div>
            </b-collapse>
        </div>
    </section>
</template>

<script>
    export default {
        name: "PrivacyPolicy",
        computed: {
            agbSections: function () {
                return [
                    {
                        agbSectionTitle: this.$t('ppDatenschutzerklärungtitle'),
                        agbSectionContent: this.$t('ppDatenschutzerklärungContent')
                    },
                    {
                        agbSectionTitle: this.$t('ppVerantwortlichkeitTitle'),
                        agbSectionContent: this.$t('ppVerantwortlichkeitContent')
                    },
                    {
                        agbSectionTitle: this.$t('ppErhebungVonDatenTitle'),
                        agbSectionContent: this.$t('ppErhebungVonDatenContent')
                    },
                    {
                        agbSectionTitle: this.$t('ppVerwendungVonDatenTitle'),
                        agbSectionContent: this.$t('ppVerwendungVonDatenContent')
                    },
                    {
                        agbSectionTitle: this.$t('ppWeitergabeVonDatenTitle'),
                        agbSectionContent: this.$t('ppWeitergabeVonDatenContent')
                    },
                    {
                        agbSectionTitle: this.$t('ppDatenspeicherungUndDatensicherheitTitle'),
                        agbSectionContent: this.$t('ppDatenspeicherungUndDatensicherheitContent')
                    },
                    {
                        agbSectionTitle: this.$t('ppIhreRechteTitle'),
                        agbSectionContent: this.$t('ppIhreRechteContent')
                    },
                    {
                        agbSectionTitle: this.$t('ppAktualisierungDieserDatenschutzerklärungTitle'),
                        agbSectionContent: this.$t('ppAktualisierungDieserDatenschutzerklärungContent')
                    },
                    {
                        agbSectionTitle: this.$t('ppErreichbarkeitTitle'),
                        agbSectionContent: this.$t('ppErreichbarkeitContent')
                    },
                    
                ]
            }
        }
    }
</script>

<style scoped>
    .textleft {
        text-align: left;
    }
    .linebreak {
        white-space: pre-line;
    }
</style>